var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustrySpaHeroGradient75148B39D262E597C5965F447A8C737E(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1400,
    viewBox: "0 0 2000 1400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19624_115894)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19624_115894)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.78,
    cy: 261.48,
    rx: 370.78,
    ry: 261.48,
    transform: "matrix(0.985464 0.169886 -0.127789 0.991801 1106.21 244.661)",
    fill: "#5AC43B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_19624_115894)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.061,
    cy: 470.416,
    rx: 376.061,
    ry: 470.416,
    transform: "matrix(0.258819 0.965926 -0.949327 0.314289 1524.34 260.874)",
    fill: "#B1EEA1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_19624_115894)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.061,
    cy: 470.416,
    rx: 376.061,
    ry: 470.416,
    transform: "matrix(0.258819 0.965926 -0.949327 0.314289 1056.17 116.939)",
    fill: "#C5FF00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19624_115894",
    x: 800.416,
    y: 29.2155,
    width: 1275.54,
    height: 1075.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135.417,
    result: "effect1_foregroundBlur_19624_115894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_19624_115894",
    x: 537.376,
    y: 199.126,
    width: 1275.43,
    height: 1145.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90.2778,
    result: "effect1_foregroundBlur_19624_115894"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_19624_115894",
    x: 69.2032,
    y: 55.1917,
    width: 1275.43,
    height: 1145.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90.2778,
    result: "effect1_foregroundBlur_19624_115894"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19624_115894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 1400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrySpaHeroGradient75148B39D262E597C5965F447A8C737E);
export default __webpack_public_path__ + "static/media/Industry_Spa_Hero_Gradient-75148b39d262e597c5965f447a8c737e.75148b39d262e597c5965f447a8c737e.svg";
export { ForwardRef as ReactComponent };